module.exports = __webpack_public_path__ + "static/2cdbbb71ef6feb39549fdd26154df751d6a238767bff1a41c48ab16c8d33310c-ad92deb6b1f5d937c40d59aaba7b587a.png";